module.exports = __webpack_public_path__ + "img/step-address-blue.svg";